import * as types from '../actions/types';
import {defaultQuizState} from '../../helpers/quiz';
import _ from 'lodash';

const initialQuiz = _.clone(defaultQuizState);

const defaultCounty = {
  'StateName': '',
  'StateAbbr': '',
  'Zip': '',
  'City': '',
  'County': '',
  'RatingRegion': false,
  'SmallBusiness': false,
  'Individual': false,
  'Medicare': false,
  'ChildHealthPlus': false,
  'Medicaid': false,
  'Essential': false
};

let newState = null;

const quizReducer = (state = initialQuiz, action) => {
  switch (action.type) {
    case types.SET_STEP:
      newState = _.clone(state);
      newState.step = action.step;
      return newState;

    case types.UPDATE_AGE:
      return _.merge({}, state, {
        'fieldValues': {
          'Age': action.age
        }
      });

    case types.SELECT_FAMILY_TYPE:
      return _.merge({}, state, {
        'fieldValues': {
          'FamilyType': action.famType
        }
      });

    case types.UPDATE_ZIP:
      let { county } = action;
      if (_.isUndefined(county) || !county.hasOwnProperty('Zip')) county = defaultCounty;

      return _.merge({}, state, {
        'fieldValues': {
          'ZipCode': action.zip,
          'Location': {
            'loc': _.clone(county)
          }
        },
        'location': {
          'loc': _.clone(county)
        }
      });

    case types.SELECT_BUDGET:
      return _.merge({}, state, {
        'fieldValues': {
          'CostPreference': action.budget
        },
        'step': state.step + 1
      });

    case types.SELECT_TRAVEL:
      return _.merge({}, state, {
        'fieldValues': {
          'MedicareTravel': action.travel
        },
        'step': state.step + 1
      });

    case types.UPDATE_HOUSEHOLD_SIZE:
      return _.merge({}, state, {
        'fieldValues': {
          'TotalFamilySize': action.householdSize
        }
      });

    case types.UPDATE_KIDS_COUNT:
      return _.merge({}, state, {
        'fieldValues': {
          'KidsCount': action.kidsCount
        }
      });

    case types.UPDATE_INCOME:
      return _.merge({}, state, {
        'fieldValues': {
          'IncomeYearly': action.income
        }
      });

    case types.UPDATE_QUOTE:
      return _.merge({}, state, {
        'fieldValues': {
          'Quote': action.quote
        }
      });

    case types.SELECT_MEDICARE:
      return _.merge({}, state, {
        'fieldValues': {
          'Medicare': action.medicareYN
        }
      });

    case types.UPDATE_EMPLOYEE_COUNT:
      return _.merge({}, state, {
        'fieldValues': {
          'FullTimeEmployees': action.numOfEmployees,
          'Quote': 'small-business'
        }
      });

    case types.SELECT_EMPLOYEE_BUDGET:
      return _.merge({}, state, {
        'fieldValues': {
          'MetalLevel': parseFloat(action.employeeBudget)
        },
        'step': state.step + 1
      });

    case types.SELECT_EMPLOYEE_PREF:
      return _.merge({}, state, {
        'fieldValues': {
          'CostPreference': parseFloat(action.employeePref)
        }
      });

    case types.START_OVER:
      return _.merge({}, state, initialQuiz);

    case types.SET_FIELD_VALUE:
      const newFieldValues = _.clone(state.fieldValues);

      newFieldValues[action.fieldKey] = action.fieldValue;

      return _.merge({}, state, {
        'fieldValues': newFieldValues
      });

    case types.SET_VISIBILITY:
      const newValue = _.clone(state);
      newValue.show[action.key] = action.value;

      return _.merge({}, state, { newValue });

    default:
      return state;
  }
};

export default quizReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/quiz.js